import { render, staticRenderFns } from "./editParceling.vue?vue&type=template&id=06bf8350&"
import script from "./editParceling.vue?vue&type=script&lang=js&"
export * from "./editParceling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06bf8350')) {
      api.createRecord('06bf8350', component.options)
    } else {
      api.reload('06bf8350', component.options)
    }
    module.hot.accept("./editParceling.vue?vue&type=template&id=06bf8350&", function () {
      api.rerender('06bf8350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inOutBound/dialog/editParceling.vue"
export default component.exports